module.exports = __webpack_public_path__ + "img/ico-brazil_BIG.33cc190b.png";